import React from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import { primaryColor } from '../../constants/Colors';

interface VersionSelectProps {
  list: {
    id: number;
    createdAt: string;
  }[];
  selectVersion: number;
  versionChange: (versionId: number, productInfoId?: number) => void;
  productInfoId?: number;
}

const VersionSelect = (props: VersionSelectProps): JSX.Element => {
  const { list, selectVersion, versionChange, productInfoId } = props;

  return (
    <FormControl
      variant="standard"
      sx={{ m: 1, width: 120, margin: 0 }}
      size="small"
      onClick={(e) => e.stopPropagation()}
    >
      <Select
        displayEmpty
        value={selectVersion}
        onChange={(e) => {
          e.stopPropagation();
          productInfoId
            ? versionChange(Number(e.target.value), productInfoId)
            : versionChange(Number(e.target.value));
        }}
        sx={{
          '&:before': {
            border: 'none'
          },
          '&:focus': {
            '&:before': {
              border: 'none'
            }
          },
          '&:hover:not(.Mui-disabled, .Mui-error)': {
            '&:before': {
              border: 'none'
            }
          },
          '& .MuiSelect-select:focus': {
            background: 'none'
          },
          width: '120px',
          border: 'none',
          fontSize: '12px',
          color: primaryColor
        }}
      >
        {list.map((date) => (
          <MenuItem
            key={date.id}
            value={date.id}
            sx={{ fontSize: '12px', color: primaryColor }}
          >
            {date.createdAt}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
export default VersionSelect;
